const { MinimogThemeStyles, MinimogThemeScripts } = window;

class QuickView {
  constructor() {
    this.modal = new MinimogTheme.Modal();
    this.isOpen = false;
    this.isLoading = false;

    addEventDelegate({
      selector: ".m-product-quickview-button",

      handler: (e, target) => {
        e.preventDefault();

        if (this.isLoading) return;

        this.target = target;
        this.toggleLoading(true);

        const productHandle =
          target.dataset.productHandle;

        if (productHandle) {
          this.loadProductQuickView(productHandle);
        }
      },
    });


    window.MinimogEvents.subscribe(
      MinimogTheme.pubSubEvents.cartUpdate,
      () => {
        if (this.modal) {
          this.modal.close();
        }
      }
    );


    window.MinimogEvents.subscribe(
      "ON_MODAL_CLOSED",
      () => {
        this.close();
      }
    );
  }


  loadProductQuickView(productHandle) {

    if (this.isOpen) {
      this.modal && this.modal.close();
    }

    this.isLoading = true;


    fetchSection("product-quickview", {
      url:
        `${window.MinimogSettings.base_url}products/${productHandle}`,
    })

      .then((html) => {

        this.modalContent =
          html.querySelector(
            "#MainProduct-quick-view__content"
          );


        const productInfo =
          html.querySelector("product-info");


        if (!this.modalContent || !productInfo) {
          throw new Error(
            "Quick View content could not be loaded."
          );
        }


        const colorScheme =
          productInfo.dataset.colorScheme;


        this.modal.appendChild(
          this.modalContent
        );


        const sectionWrapper =
          this.modal.modal.querySelector(
            "#MainProduct-quick-view__content"
          );


        sectionWrapper
          .querySelectorAll("script")
          .forEach((oldScriptTag) => {

            const newScriptTag =
              document.createElement("script");


            Array.from(
              oldScriptTag.attributes
            ).forEach((attribute) => {

              newScriptTag.setAttribute(
                attribute.name,
                attribute.value
              );

            });


            newScriptTag.appendChild(
              document.createTextNode(
                oldScriptTag.innerHTML
              )
            );


            oldScriptTag.parentNode.replaceChild(
              newScriptTag,
              oldScriptTag
            );

          });


        /* Open the existing Minimog modal */
        this.modal.open();


        this.modal.setSizes(
          `m-gradient ${colorScheme}`
        );


        /*
        ====================================
        VIVEE BOTTOM QUICK VIEW
        ====================================
        */


        const modalWrapper =
          sectionWrapper.closest(".m-modal");


        const modalContent =
          sectionWrapper.closest(
            ".m-modal__content"
          );


        const modalInner =
          sectionWrapper.closest(
            ".m-modal__content-inner"
          );


        if (modalWrapper) {

          modalWrapper.style.setProperty(
            "align-items",
            "flex-end",
            "important"
          );

          modalWrapper.style.setProperty(
            "justify-content",
            "center",
            "important"
          );

          modalWrapper.style.setProperty(
            "padding",
            "0",
            "important"
          );

        }


        if (modalContent) {

          modalContent.style.setProperty(
            "width",
            "100%",
            "important"
          );

          modalContent.style.setProperty(
            "max-width",
            "100%",
            "important"
          );

          modalContent.style.setProperty(
            "margin",
            "0",
            "important"
          );

          modalContent.style.setProperty(
            "border-radius",
            "0",
            "important"
          );

        }


        if (modalInner) {

          modalInner.style.setProperty(
            "width",
            "100%",
            "important"
          );

        }


        sectionWrapper.style.setProperty(
          "width",
          "100%",
          "important"
        );


        /*
        ====================================
        END VIVEE BOTTOM QUICK VIEW
        ====================================
        */


        this.toggleLoading(false);

        this.isOpen = true;
        this.isLoading = false;

      })


      .then(() => {

        document.dispatchEvent(
          new CustomEvent(
            "tcustomizer-custom-show-quick-view",
            {
              detail: {
                productHandle:
                  this.target.dataset.productHandle,
              },
            }
          )
        );


        document.dispatchEvent(
          new CustomEvent(
            "quick-view:loaded",
            {
              detail: {
                productUrl:
                  this.target.dataset.productHandle,
              },
            }
          )
        );

      })


      .catch((error) => {

        console.error(
          "Error loading product quick view:",
          error
        );

        this.toggleLoading(false);

        this.isLoading = false;

      });

  }


  close() {
    this.isOpen = false;
    this.isLoading = false;
  }


  toggleLoading(isLoading) {

    if (!this.target) return;


    if (isLoading) {

      this.target.classList.add(
        "m-spinner-loading"
      );

    } else {

      this.target.classList.remove(
        "m-spinner-loading"
      );

    }

  }
}


MinimogTheme.ProductQuickView =
  new QuickView();